const TRIOPS_CHECK_CODE_URL = 'https://clementoni-triops-3bwc5olfka-ew.a.run.app/check-code'; // Live triops
// const TRIOPS_CHECK_CODE_URL = 'https://triops-cloudrun-7gmxy4kurq-ew.a.run.app/check-code'; // Dev triops
const CONTACT_FORM_URL = 'https://clementoni-zendesk-3bwc5olfka-ew.a.run.app/index.php'; // Live zendesk

const PUZZLE_USERNAME = 'WgFpCB65s33kT46gJbuw';
const PUZZLE_PASSWORD = 'xb9HCmR3ZXwFR@!#K?N6';
const PUZZLE_TYPE = 'password';
const PUZZLE_URL = 'https://clemcloudordlav.azurewebsites.net/token';
const PUZZLE_URL_CODE = 'https://clemcloudordlav.azurewebsites.net/api/Servizi/GetOrdine';

const MSG = {
  required: "Champs requis",
  email: "Insérez un email valide",
  toobig: "Le fichier est trop volumineux, veuillez insérer des fichiers de moins de 2,5 Mo",
  jpg: "Insérer une image JPG",
  chars: "Le code est de 16 caractères",
  error: "Quelque chose s\'est mal passé. Réessayer",
  triopsCode: 'Entrez un code',
  loading: "S\'il vous plaît, attendez...",
  triopsErr1: 'Erreur du serveur. Contactez nous s\'il vous plait. Erreur:',
  tripsErr2: 'Erreur du serveur. Contactez nous s\'il vous plait.',
  sending: "Envoi en cours..."
}

$(document).ready(function(){
  triops();
  if($('#form_assistenza').length)
    assistenza();
  toggleModal();
});

function assistenza(){
  var formValid = true;
  var submitting = false;
  var isPuzzle = false;
  var index = 0;
  var form = '#form_assistenza';
  var inputType = "#ContactFormTipo";
  var inputPuzzle = "#ContactFormPuzzleCode";
  var inputCode = "#ContactFormCodiceProdotto";
  var inputCountry = "#ContactFormNazione";
  var inputProv = "#ContactFormProvincia";
  var btnShow = "#show-form";

  init();

  function init(){
    $('input,textarea,select').on('blur', function(e){
      validateInput(this);
    });

    $(inputType).on('change', function(){
      openPuzzle();
    });

    $(inputCountry).on('change', function(){
      checkProvRequired();
    });

    $('[data-form-submit]').on('click', function(){
      validate(submitForm);
    });

    $(btnShow).on('click', function () {
      location.reload();
    });

    checkProvRequired();
  }

  function submitForm(){
    if(formValid && !submitting){
      submitting = true;
      $(form).find('[data-form-submit]').text(MSG.sending);
      $(form).find('[type=email]').each(function(){
        var val = $(this).val().toLowerCase().trim();
        $(this).val(val);
      });
      const data_contact = new FormData($(form)[0]);
      if ($('#immagine').length > 0){
        files = $('#immagine')['0'].files;
        $.each( files, function( key, value ){
          data_contact.append( key, value );
        });
      }

      $.ajax({
        url: CONTACT_FORM_URL,
        method: "POST",
        enctype: 'multipart/form-data',
        contentType: false,
        processData: false,
        data: data_contact,
        cache: false,
        success: function (res){
          if (res.ticket_id){
            $('.page__contact-form').hide();
            $('.contact_form_sucess_name').text($('#ContactFormName').val()+' '+$('#ContactFormCognome').val());
            $('.ticket_code').text(res.ticket_id);
            $('.contact_form_sucess').show();
            $('.contact_form_sucess').get(0).scrollIntoView();
            submitting = false;
          }
          else{
            console.log(res);
            $(form).find('[data-form-submit]').text(MSG.triopsErr1 + JSON.stringify(res));
            submitting = false;
          }
        },
        error: function (err){
          console.log(err);
          $(form).find('[data-form-submit]').text(MSG.triopsErr1 + JSON.stringify(err.responseJSON.message));
          submitting = false;
        }
      });	
    }
  }

  function validate(c){
    formValid = true;
    index = 0;
    var inputs = [];
    $(form).find('input,textarea,select').each(function(){
      inputs[inputs.length] = this;
    });
    validateInput(inputs[index], function(){
      continueValidate(inputs, c);
    });
  }

  function continueValidate(inputs, cc){
    index++;
    if(index < inputs.length){
      validateInput(inputs[index], function(){
        continueValidate(inputs, cc);
      });
    }
    else{
      cc();
    }
  }
  
  function validateInput(input, callback){
    var val = $(input).val();
    var valid = true;
    var isCorrectingPuzzle = isPuzzle && ($(input).attr('id') == $(inputPuzzle).attr('id'));
    var msg = '';

    if(val == "" || val == undefined || val == null){
      valid = $(input).attr('required') == undefined || $(input).attr('required') == null;
      msg = MSG.required;
      isCorrectingPuzzle = isCorrectingPuzzle ? valid : isCorrectingPuzzle;
    }
    else{
      if($(input).attr('type') == 'email' && !isEmail(val)){
        valid = false;
        msg = MSG.email;
      }
      else if($(input).attr('type') == 'file'){
        var res = validateFile(input);
        valid = res.valid;
        msg = res.msg;
      }
      else if(isCorrectingPuzzle){
        if(val.length == 16)
          validatePuzzle(callback);
        else{
          valid = false;
          msg = MSG.chars;
        }
      }
    }
    var x = setError(input, valid, msg);
    if(!isCorrectingPuzzle && callback !== undefined && callback != null && x)
      callback();
  }

  function validateFile(input){
    var file = $(input).get(0).files[0];
    var ret = {valid: true, msg: ''};
    if(file != undefined){
      if($(input).attr('data-form-size') != undefined && file.size > parseInt($(input).attr('data-form-size'))){
        ret.valid = false;
        ret.msg = MSG.toobig;
      }
      else if($(input).attr('data-form-extensions') != undefined){
        var exts = $(input).attr('data-form-extensions').split(',');
        var ext = file.name.split('.');
        ext = ext[ext.length-1].toLowerCase();
        var f = false;
        $(exts).each(function(){
          if(this.localeCompare(ext) == 0){
            f = true;
          }
        });
        if(!f){
          ret.valid = false;
          ret.msg = MSG.jpg;
        }
      }
    }
    return ret;
  }

  function openPuzzle(){
    var type = parseInt($(inputType).val());
    isPuzzle = type == 2;
    $(inputPuzzle).attr('required', isPuzzle).val("");
    $(inputCode).attr('readonly', isPuzzle);
    if(isPuzzle){
      $(inputPuzzle).parents('[data-form-parent]').removeClass('puzzle');
    }
    else{
      $(inputPuzzle).parents('[data-form-parent]').addClass('puzzle');
    }
  }

  function validatePuzzle(callback){
    if(isPuzzle && !submitting){
      submitting = true;
      $(inputPuzzle).attr('readonly', true);
      var val = $(inputPuzzle).val();

      $.ajax({
        "url": PUZZLE_URL,
        "method": "POST",
        "timeout": 0,
        "headers": {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        "data": {
          "username": PUZZLE_USERNAME,
          "password": PUZZLE_PASSWORD,
          "grant_type": PUZZLE_TYPE
        },
        success: function (res){
          if(res.access_token != undefined){
            $.ajax({
              "url": PUZZLE_URL_CODE+"?value="+val,
              "method": "GET",
              "timeout": 0,
              "headers": {
                "Content-Type": "application/x-www-form-urlencoded",
                "Authorization": "Bearer " + res.access_token,
              },
              "data": {
                "username": PUZZLE_USERNAME,
                "password": PUZZLE_PASSWORD,
                "grant_type": PUZZLE_TYPE
              },
              success: function (code){
                submitting = false;
                if(code.indexOf("KO") >= 0){
                  var msg = code.split('-');
                  setPuzzleError(res, msg[1], callback);
                }
                else{
                  setError(inputPuzzle, true);
                  $(inputCode).val(code);
                  if(callback != undefined && callback != null)
                    callback();
                }
              },
              error: function (err){
                setPuzzleError(err, err.responseJSON.message, callback);
              }
            });	
          }
          else{
            setPuzzleError(res, MSG.error, callback);
          }
        },
        error: function (err){
          setPuzzleError(err, err.responseJSON.message, callback);
        }
      });	
    }
  }

  function setPuzzleError(err, msg, callback){
    console.log(err);
    setError(inputPuzzle, false, msg);
    submitting = false;
    $(inputPuzzle).attr('readonly', false);
    if(callback != undefined && callback != null)
      callback();
  }

  function setError(input, valid, msg){
    var parent = $(input).parents('[data-form-parent]');
    var x = false;
    if(valid){
      $(parent).removeClass('invalid');
      $(parent).find('.form-error').text('');
      x = true;
    }
    else{
      $(parent).addClass('invalid');
      $(parent).find('.form-error').text(msg);
      formValid = false;
      x = true;
    }
    return x;
  }

  function checkProvRequired() {
    var data = $(inputCountry).find('option:selected').attr('data-prov-required');
    if ((data !== undefined) && (data.toLowerCase() !== "false")) {
      $(inputProv).prop('required', true);
      $('.provincia_req').show();
    }
    else {
      $(inputProv).prop('required', false);
      $('.provincia_req').hide();
      setError(inputProv, true);
    }
  }
}


var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}

function triops(){
  $('#verify_triops_submit').click(function () {
    var code = $('#verify_triops').val() || '';
    var customer_id = $('#verify_triops_cusomer_id').val();
    var msg =  $('#verify_triops_msg');
    var btn = $('#verify_triops_submit');
    // Clear msg
    msg.removeClass('error');
    msg.removeClass('success');
    msg.text('');

    if(!code.trim()){
      msg.addClass('error');
      msg.text(MSG.triopsCode);
      return;
    }

    // Disable button and add text msg loading
    btn.prop( "disabled", true );
    msg.text(MSG.loading);

    $.ajax({
      url: TRIOPS_CHECK_CODE_URL,
      method: "POST",
      data: { code, customer_id },
      dataType: "json",
      success: function (data){
        // Remove loading... message
        msg.text('');
        btn.prop( "disabled", false );
        var classMessage = data.status ? 'success' : 'error';
        msg.addClass(classMessage);
        msg.text(data.message);
        return;
      },
      error: function (err){
        const codeError = err.responseJSON && err.responseJSON.errorCode ? err.responseJSON.errorCode : null;
        const errMsg = codeError ? MSG.triopsErr1 + codeError : MSG.triopsErr2;
        // Remove loading... message
        msg.text('');
        btn.prop( "disabled", false );
        msg.addClass('error');
        msg.text(errMsg);
        return;
      }
    });	
  });
}

function isEmail(email){
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function isPhone(phone){
    const re = /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
    return re.test(String(phone).toLowerCase());
}

// function toggleModal(){
//   $('[data-toggle="modal"]').on('click', function(){
//     $($(this).attr('data-target')).toggleClass('show');
//   });
//   $('[data-dismiss="modal"]').on('click', function(){
//     $('.modal').removeClass('show');
//   });
// } 

function toggleModal(){
   return;
}